<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-30 18:50:53
 * @FilePath: \jyrg-web\src\views\pc\information\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="main">
    <SecondPage>
       <!-- 标签切换区域 -->
       <div class="tab-buttons">
        <button 
          v-for="btn in  $config.dataInfoList" 
          :key="btn.selectType" 
          @click="toggleTab(btn.selectType)" 
          :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
        >
            <div  :class="'tab-title'+ btn.tab">{{ btn.title }}</div>
                <img
                  :src="btn.backgroundImg"
                  alt=""
                  :class="'people-tab' + btn.tab"
                />
        </button>
      </div>
      <div style="padding: 35px 0" v-if="currentTab === 'official' ">
        <div 
          class="information-content"
          v-for="item in gameDataList"
          :key="item.strategyType"
          
          
        >
          <div class="header">
            <div class="title">
              <span>{{ item.strategyType }}</span>
            </div>
          </div>
          <div class="list">
            <div
              class="list-item"
              v-for="e in item.strategyEntity.filter((e) => e.title != '无')"
              :key="e.id"
              @click="redirectPageToGameData(e)"
            >
              <div class="list-icon"></div>
              {{ e.title }}
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 35px 0" v-if="currentTab === 'highExplosive' ">
        <div
          class="information-content"
          v-for="item in gameDataList"
          :key="item.strategyType"



        >
          <div class="header">
            <div class="title">
              <span>{{ item.strategyType }}</span>
            </div>
          </div>
          <div class="list">
            <div
              class="list-item"
              v-for="e in item.strategyEntity.filter((e) => e.title != '无')"
              :key="e.id"
              @click="redirectPageToGameData(e)"
            >
              <div class="list-icon"></div>
              {{ e.title }}
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 35px 0" v-if="currentTab === 'threeExplosive' ">
        <div
          class="information-content"
          v-for="item in gameDataList"
          :key="item.strategyType"



        >
          <div class="header">
            <div class="title">
              <span>{{ item.strategyType }}</span>
            </div>
          </div>
          <div class="list">
            <div
              class="list-item"
              v-for="e in item.strategyEntity.filter((e) => e.title != '无')"
              :key="e.id"
              @click="redirectPageToGameData(e)"
            >
              <div class="list-icon"></div>
              {{ e.title }}
            </div>
          </div>
        </div>
      </div>
    </SecondPage>
    <el-dialog :visible.sync="showVisible" append-to-body  >
      <div style="width: 100%; height: 60px; text-align: center;font-size: 24px;">暂未开放，敬请期待！</div>
   <div style=" margin-left:45%;">
     <el-button size="mini" @click="showVisible = false"
     >关闭</el-button
     >
   </div>
 </el-dialog>
  </div>
  
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SecondPage from "../component/SecondPage/SecondPage.vue";
import VoucherIndexCenter from "../../../components/public/VoucherIndexCenter";
import webSiteHigh from "../../../api/webSiteHigh";
import webSite from "../../../api/webSite";
import webSiteThree from "../../../api/webSiteThree";
export default {
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  data(){
 return{
  voucherShow:false,
  showVisible:false,
  gameDataList:[],
   currentTab: ''
 }
  },
  components: { SecondPage },

  mounted() {
    this.toggleTab();
  },
  methods: {
 
     // 切换标签
     toggleTab(tab) {
      if(tab != null && tab.trim() !== ''){
        sessionStorage.setItem('toggleTab', tab);
      }
      const storedValue = sessionStorage.getItem('toggleTab');

      if (tab === 'threeExplosive' || storedValue === 'threeExplosive' ) {
        this.currentTab="threeExplosive"
         this.getDataList(3)
      } else if (tab === 'highExplosive' || storedValue === 'highExplosive' ) {
        this.currentTab="highExplosive"
         this.getDataList(2)
      } else {
         this.currentTab="official"
         this.getDataList(1)
      }

    },
        //充值界面
        voucherCenterarHandle(state) {
      this.$refs.VoucherCenter.voucherShow = state;
    },
    async getDataList(type) {
      if(type==3){
      let gameType="游戏介绍,武学秘籍,江湖活动,副本介绍,装备大全,NPC/怪物"
      let res = await webSiteThree.searchGameData(gameType);
      this.gameDataList = res.data;

      }else if(type==2){
      let gameType="游戏介绍,武学秘籍,江湖活动,副本介绍,装备大全,NPC/怪物"
      let res = await webSiteHigh.searchGameData(gameType);
       this.gameDataList = res.data;

      }else{
      let gameType="游戏介绍,武学秘籍,江湖活动,副本介绍,装备大全,NPC/怪物"
      let res = await webSite.searchGameData(gameType);
       this.gameDataList = res.data;

      }

    },
    async redirectPageToGameData(item) {
      try {
        let { id, title } = item;
        this.$router.push({
          path: "/detail",
          query: { id, title, path: "江湖资料" },
        });
      } catch (error) {
        console.info(error);
      }
    },
  },
  // 组件路由守卫
  beforeRouteEnter(to, from, next) {
    let { title } = to.query;
    if (to.meta.title) document.title = title;
    next();
  },


};
</script>

<style lang="scss" scoped>
   .tab-buttons {
  display: flex;
  gap:30px; /* 按钮之间的间距 */
  justify-content: center; /* 按钮居中显示 */
}

.tab-button {
  /* 基础按钮样式，确保文字居中 */
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #704c13;
  padding: 20px 40px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease;
  outline: none;
  
  /* 移除默认按钮样式 */
  &:focus {
    outline: none;
  }
}

// 默认状态样式
.item-def {
  background-image: url("../../../assets/image/pc/basemap-data-def.png");
  /* 根据实际图片尺寸调整按钮大小 */
  width: 345px;
  height: 140px;

}

// 激活状态样式
.item-active {
  background-image: url("../../../assets/image/pc/basemap-data-active.png");
  color: #f4f7f6; /* 激活状态文字颜色 */

  width:345px;
  height: 140px;
}   
.tab-title1{
  width: 100%;
  font-size: 28px;
  text-align: center;
}
.tab-title2{
  width: 100%;
  font-size: 28px;
  text-align: center;
}
.tab-title3{
  width: 100%;
  font-size: 28px;
  text-align: center;
}
 .people-tab1 {
      width: 167px;
      height:197px;
      position: absolute;
      margin-left: -12%;
      margin-top: -8%;
  }
  .people-tab2 {
       width: 180px;
       height: 197px;
       position: absolute;
      // margin-right: -9%;
      margin-top: -8%;
      margin-left: 2%;
  }
  .people-tab3 {
      width: 167px;
      height:197px;
      position: absolute;
      margin-left: -12%;
      margin-top: -8%;
  }
.information-content {
  display: flex;
  flex-direction: column;
  border-bottom: 1px dashed #ccc;
  .header {
    display: flex;
    align-items: center;
    height: 70px;
    border-bottom: 1px dashed #ccc;
    .title {
      width: 130px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("../../../assets/image/pc/title-bg.png");
      background-size: 100% 100%;

      span {
        width: 95px;
        text-align: center;
        color: #3b2606;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    margin-left: 50px;
    .list-item {
      display: flex;
      align-items: center;
      text-align: start;
      width: 20%;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      .list-icon {
        width: 30px;
        height: 30px;
        background: url("../../../assets/image/pc/second-page-listicon.png");
        background-size: 100% 100%;
        margin-right: 15px;
      }
      img {
        margin-right: 5px;
      }
    }
    .list-item:hover {
      color: #d0a65e;
      text-decoration: underline;
    }
    .list-item:hover .list-icon {
      background-size: 100% 100%;
    }
  }
}
.information-content:last-child {
  border-bottom: none;
}
</style>
